// index.jsx
import './style.css'
import React, { Suspense, useState } from 'react'
import ReactDOM from 'react-dom/client'
import { Canvas, } from '@react-three/fiber'
import { Preload } from '@react-three/drei'
import Experience from './Experience.jsx'      // will accept `entered` prop
import Interface from './Interface.js'
import InfoBoxes from './InfoBoxes.js'
import InfoPopup from './InfoPopup.js'
import Dust from './Dust.js'
import EnterUI from './EnterUI.js'

function App() {
  // gate that toggles loading of non-essential/distant assets
  const [entered, setEntered] = useState(false)
  const [info, setInfo] = useState(null)
  const closePopup = () => setInfo(null)

  return (
    <>
      <Canvas
        gl={{ antialias: true, powerPreference: 'low-power' }}
        camera={{ fov: 45, near: 0.1, far: 200, position: [6, 2, 0] }}
        onPointerMissed={closePopup}
        dpr={[1, 1.5]}
        onContextLost={(e) => {
          e.preventDefault()
          console.warn('WebGL context lost')
        }}
        onContextRestored={() => console.log('WebGL context restored')}
      >

        {/*
          Essential scene (inside Suspense). EnterUI's useProgress should
          only measure the assets mounted inside this Suspense boundary.
          Keep this minimal — only things the user sees immediately.
        */}
        <Suspense fallback={null}>
          <Dust />
          <Experience entered={entered} />
          <InfoBoxes setInfo={setInfo} />
        </Suspense>

        {/*
          Deferred / distant content: only mount after user enters.
          Experience component will itself only mount heavy components
          when `entered` is true (pattern shown below).
        */}
        {entered && (
          <Suspense fallback={null}>
            {/*
              You can use Preload here to trigger remaining asset downloads
              after entry — useful to progressively fill the world.
            */}
            <Preload all />
          </Suspense>
        )}
      </Canvas>

      <Interface />
      {info && <InfoPopup info={info} onClose={closePopup} />}

      {/*
        Show Enter UI until user enters.
        EnterUI uses useProgress() — because only essential assets are mounted,
        progress will reflect only those assets.
      */}
      {!entered && <EnterUI onEnter={() => setEntered(true)} />}
    </>
  )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))
root.render(<App />)
